import { RootState } from '../index';

export const getDriversKeyword = (state: RootState) => state.drivers.keyword;

export const getDriversSort = (state: RootState) => state.drivers.sortBy;

export const getIsAddDriverMode = (state: RootState) => state.drivers.addDriverMode;
